import React from "react";
import "./Styles/Frame.css";

export const Frame = (props) => {
  return (
    <div className="frame-container">
      <iframe
        className="frame-content"
        name="frame"
        title="frame"
        src={props.src}
      />
    </div>
  );
};
